export default __webpack_public_path__ + "static/logo-ro-f67514cdc538e6ed2e941697bef0043d.png";